export default __webpack_public_path__ + "static/media/deselect.2b755728.wav";